// KYC_MODE_HEADER tells the backend which session cookie this tab is using. Editable and view-only
// sessions live in separate cookies, so a tab must say which one it holds. Sent only for view-only.
export const KYC_MODE_HEADER = 'X-ANCHORAGE-KYC-MODE';
export const VIEW_ONLY_MODE = 'view-only';

// kycModeHeaders returns the mode header to attach to API calls, empty for editable sessions.
export const kycModeHeaders = (sessionMode: string): Record<string, string> =>
  sessionMode ? { [KYC_MODE_HEADER]: sessionMode } : {};
